import React from 'react';
import Lottie from 'react-lottie';
import { FaLock } from 'react-icons/fa';
import { syncAnimation } from '../../../assets/lottie';
const isDesktop = window.innerWidth > window.innerHeight;
export const SyncAnimation = () => {
    return (React.createElement("div", { style: s.container },
        React.createElement(FaLock, { style: s.lockIcon }),
        React.createElement(Lottie, { options: { loop: true, autoplay: true, animationData: syncAnimation }, isStopped: false, isPaused: false, 
            // @ts-ignore
            style: { transform: 'scale(2)' } })));
};
const s = {
    container: {
        height: isDesktop ? '100%' : '50%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lockIcon: {
        fontSize: isDesktop ? '3.5vw' : '12vw',
        color: '#FFFFFF',
        position: 'absolute',
    },
};
export default SyncAnimation;
